import { Client, Account, Databases } from 'appwrite';

const APPWRITE_ENDPOINT =
  process.env.REACT_APP_APPWRITE_ENDPOINT || 'https://fra.cloud.appwrite.io/v1';
const APPWRITE_PROJECT_ID =
  process.env.REACT_APP_APPWRITE_PROJECT_ID || 'kalugiradashboard';

const client = new Client();
client
    .setEndpoint(APPWRITE_ENDPOINT)
    .setProject(APPWRITE_PROJECT_ID);

export const account = new Account(client);
export const databases = new Databases(client);

// Database ID: kalugiraDashboard (all collections live in this database)
export const DATABASE_ID = 'kalugiraDashboard';
export const COLLECTION_ID_PURCHASE_ORDERS = 'purchaseOrders'; // You'll need to create this collection in Appwrite
/** Cable delivery grid per PO (create with npm run setup:cable-deliveries) — display name: Cable deliveries */
export const COLLECTION_ID_CABLE_DELIVERIES = 'CableDeliveriesSGM';
/** Concrete poles delivery grid per PO (create with npm run setup:concrete-poles-deliveries) */
export const COLLECTION_ID_CONCRETE_POLES_DELIVERIES = 'ConcretePolesDeliveriesSGM';
/** PO Quantities contract qty per scope (optional; app falls back to Cable deliveries slot) */
export const COLLECTION_ID_DELIVERY_CONTRACT_QTY = 'DeliveryContractQtySGM';

export const COLLECTION_ID_SUPPLIERS = 'Suppliers22'; // Collection ID for Suppliers 22 (Appwrite doesn't allow spaces in IDs)
export const COLLECTION_ID_CASUAL_PAYMENT = 'CasualPaymentSGM'; // Collection ID for Casual Payment SGM (Appwrite doesn't allow spaces in IDs)
export const COLLECTION_ID_TEAM = 'TeamSGM'; // Collection ID for Team SGM (Appwrite doesn't allow spaces in IDs)
export const COLLECTION_ID_TOOLS_INVENTORY = 'ToolsInventorySGM'; // Collection ID for Tools Inventory SGM (Appwrite doesn't allow spaces in IDs)
export const COLLECTION_ID_INVOICE_TRACKING = 'InvoicesTrackingSGM'; // Collection ID for Invoices tracking SGM (Appwrite doesn't allow spaces in IDs)
export const COLLECTION_ID_TASK_MANAGEMENT = 'TaskManagementSGM'; // Collection ID for Task Management SGM (Appwrite doesn't allow spaces in IDs)
/** Task comments — create with npm run setup:task-comments (never deletes existing resources) */
export const COLLECTION_ID_TASK_COMMENTS = 'TaskCommentsSGM';
export const COLLECTION_ID_VEHICLES = 'VehiclesSGM'; // Vehicles (for Vehicle Report dropdown)
export const COLLECTION_ID_VEHICLE_REPORTS = 'VehicleReportsSGM'; // Vehicle monthly reports (legacy form)
/** Vehicle report grid rows (create with npm run setup:vehicle-report-grid) */
export const COLLECTION_ID_VEHICLE_REPORT_GRID = 'VehicleReportGridSGM';
/** Rental Payment Trucking (create with scripts/setupRentalPaymentTruckingCollections.js) */
export const COLLECTION_ID_RENTAL_PO_TRACKING = 'RentalPOTrackingSGM';
export const COLLECTION_ID_RENTAL_INVOICE_TRACKING = 'RentalInvoiceTrackingSGM';
export const COLLECTION_ID_RENTAL_COMPANIES = 'RentalCompaniesSGM';
/** TotalEnergies PO rows (Fuel Report tab); create with npm run setup:total-energies-po */
export const COLLECTION_ID_TOTAL_ENERGIES_PO = 'TotalEnergiesPOSGM';
/** TotalEnergies fuel invoices (Fuel Report → TotalEnergies Invoices); create with npm run setup:total-energies-invoices */
export const COLLECTION_ID_TOTAL_ENERGIES_INVOICES = 'TotalEnergiesInvoicesSGM';
/**
 * Poles delivery row-level edits (Delivery Tracking → Poles tab).
 * One document per Poles spreadsheet row, keyed by `rowKey` (a stable digest
 * of the Hamlet info columns). Stores all editable cell values for that row
 * — Delivered Quantities, DN/Date/Supplier, PO/Invoice,
 * Payment Status — as a JSON blob in the `edits` attribute.
 * Create with: npm run setup:poles-deliveries
 */
export const COLLECTION_ID_POLES_DELIVERIES = 'PolesDeliveriesSGM';
/** Car rental monthly invoicing (create with npm run setup:car-rentals) */
export const COLLECTION_ID_CAR_RENTALS = 'CarRentalsSGM';
/** App login users — email + PIN (create with npm run setup:app-users) */
export const COLLECTION_ID_APP_USERS = 'AppUsersSGM';
/** Vehicle Inspection Report (VIR) submissions — create with npm run setup:vir-reports */
export const COLLECTION_ID_VIR_REPORTS = 'VirReportsSGM';
/** Driving licenses — create with npm run setup:driving-licenses */
export const COLLECTION_ID_DRIVING_LICENSES = 'DrivingLicensesSGM';
/** Service cards — create with npm run setup:service-cards */
export const COLLECTION_ID_SERVICE_CARDS = 'ServiceCardsSGM';
/** Fuel fill-up logs — create with npm run setup:fuel-logs */
export const COLLECTION_ID_FUEL_LOGS = 'FuelLogsSGM';
/** Driver information + photo — create with npm run setup:driver-profiles */
export const COLLECTION_ID_DRIVER_PROFILES = 'DriverProfilesSGM';
/** Vehicle list status + remark overrides — create with npm run setup:vehicle-status */
export const COLLECTION_ID_VEHICLE_STATUS = 'VehicleStatusSGM';
/** Local Transportation Trucking rows — create with npm run setup:local-transport-trucking */
export const COLLECTION_ID_LOCAL_TRANSPORT_TRUCKING = 'LocalTransportTruckingSGM';
/** Fleet admin fuel invoices spreadsheet — create with npm run setup:fleet-fuel-invoices */
export const COLLECTION_ID_FLEET_FUEL_INVOICES = 'FleetFuelInvoicesSGM';

export default client;

